import React, {useCallback, useEffect, useRef, useState} from "react";
import api from "../../api/client";
import LoadingInside from "../../components/Loading/LoadingInside";
import ComboHorizontalScroller from "../../components/ComboHorizontalScroller/ComboHorizontalScroller";
import SeoMeta from "../../components/SeoMeta";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import titleImage from "../../assets/images/titleImage.png";
import s from "../SpecialOffers/SpecialOffers.module.scss";

const apiUrl = process.env.REACT_APP_API_URL;

const ComboTours = () => {
    const [combos, setCombos] = useState([]);
    const [comboPage, setComboPage] = useState(1);
    const [hasMoreCombos, setHasMoreCombos] = useState(true);
    const [loadingCombos, setLoadingCombos] = useState(true);
    const [loadingMoreCombos, setLoadingMoreCombos] = useState(false);
    const loadingMoreCombosRef = useRef(false);

    const breadcrumbItems = [
        {name: "ホーム", link: "/"},
        {name: "コンボツアー"}
    ];

    const loadCombos = useCallback(async (
        pageNumber = 1,
        reset = false
    ) => {

        if (loadingMoreCombosRef.current) return;

        loadingMoreCombosRef.current = true;

        if (reset) {
            setLoadingCombos(true);
        } else {
            setLoadingMoreCombos(true);
        }

        try {

            const res = await api.get(
                `${apiUrl}/api/combo-tours`,
                {
                    params: {
                        page: pageNumber
                    }
                }
            );

            const data = res.data.data || [];
            const lastPage = res.data.last_page || pageNumber;

            if (reset) {

                setCombos(data);

            } else {

                setCombos(prev => [
                    ...prev,
                    ...data
                ]);

            }

            setHasMoreCombos(pageNumber < lastPage);
            setComboPage(pageNumber);

        } finally {

            setLoadingCombos(false);
            setLoadingMoreCombos(false);
            loadingMoreCombosRef.current = false;

        }
    }, []);

    useEffect(() => {
        loadCombos(1, true);
    }, [loadCombos]);

    return (
        <>
            <SeoMeta
                slug={window.location.pathname}
                fallback={{
                    title: "コンボツアー",
                    description: "コンボツアー"
                }}
            />
            <div className={s.page}>
                <div className="row mt-3 mb-3">
                    <div className="col-12">
                        <Breadcrumb items={breadcrumbItems}/>
                        <div className={s.titleWrrapper}>
                            <img className={s.titleImage} src={titleImage} alt=""/>
                            <h2 className={s.primaryTitle}>コンボツアー</h2>
                            <h3 className={s.secondaryTitle}>お得な複数都市ツアー</h3>
                        </div>
                    </div>
                </div>

                <div className={s.tourArea}>


                    {loadingCombos ? (
                        <LoadingInside height="40vh"/>
                    ) : (
                        <ComboHorizontalScroller
                            combos={combos}
                            loadMore={() => loadCombos(comboPage + 1)}
                            hasMore={hasMoreCombos}
                            loading={loadingMoreCombos}
                        />
                    )}
                </div>
            </div>
        </>
    );
};

export default ComboTours;
